import styles from "./Home.module.css";
import Header from "./Header";
import Footer from "./Footer";
import React, { useEffect, useState } from "react";
import useFetchProducts from "../hooks/useFetchProducts";

function Home() {
  
  const {Data, Loading, Sort} = useFetchProducts();
  const [featured, setFeatured] = useState(null);
  const [tempFeatured, setTempFeatured] = useState(null);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [sliderPause, setSliderPause] = useState(false);

  useEffect(()=>{
    const tempFeaturedArray = [
      {
        image: "https://res.cloudinary.com/dvxhuwhbr/image/upload/v1783084882/products/hrup6kgxgwtz9jsu8ayx.png",
        link: "/product/6a40cab2d27006748f2343bc?variant=6a40cb21d27006748f2343d2"
      },
      {
        image: "https://res.cloudinary.com/dvxhuwhbr/image/upload/v1783143795/products/otualssjbsqqiefkmbrg.png",
        link: "/product/69c24038ccb8cc82057b537d?variant=69c27b2cb66ad7d234ea92ea"
      },
      {
        image: "https://res.cloudinary.com/dvxhuwhbr/image/upload/v1783084962/products/jyzlhucdiewrorqavwye.png",
        link: "/product/69c215eeb6c45bcc9cb0201e?variant=69c545e8fb63a2c1ae219dc5"
      },
      {
        image: "https://res.cloudinary.com/dvxhuwhbr/image/upload/v1783086848/products/mdgmwkdfcvolrlekjbh7.png",
        link: "/product/6a40c750d27006748f23430e?variant=6a40c792d27006748f234322"
      },
    ];
    const initializeSlider = () =>{
      if(!tempFeatured || !Array.isArray(tempFeatured)) setTempFeatured(tempFeaturedArray);
      if(!tempFeatured || !Array.isArray(tempFeatured) || !tempFeatured[0]) return;
      if(!featured) setFeatured([tempFeatured[0]]);
    }
    if(!featured) initializeSlider();
  }, [featured, tempFeatured]);

  useEffect(()=>{
    if(!Array.isArray(featured) || featured.length <= 1 || sliderPause) return;
    const slider = setInterval(()=> {
      if(featured.length === 1 || sliderPause) clearInterval(slider);
      setCurrentSlide((prev)=>prev+1>=featured.length?0:prev+1);
    }, 7000);
    return ()=>clearInterval(slider);
  }, [featured, sliderPause]);


  const handleLoad = (e)=>{
    e.target.classList.add(styles.loaded);
  }
  const appendNextSlide = () =>{
    if(!Array.isArray(tempFeatured) || !tempFeatured[0] || !Array.isArray(featured)) return;
    const slideCount = tempFeatured.length-1;
    const featuredCount = featured.length-1;
    if(featuredCount < slideCount) {
      setFeatured(prev=>[...prev, tempFeatured[featuredCount+1]]);
    }
  }
  const featuredSlider = Array.isArray(featured) ? (
    <>
    <div className={styles.featuredAdsWrapper}  onMouseOver={()=>setSliderPause(true)}  onMouseOut={()=>setSliderPause(false)}>
      <div className={styles.featuredSlider} style={{transform: `translateX(-${currentSlide * 100}%)`}}>
      {
        featured.map((slider, index)=>{
          return (
            <div key={index} className={styles.featuredAds}>
              <a href={slider.link?slider.link:"#product"} target="_blank" rel="noopener noreferrer">
                <img alt="product banner" src={slider.image?slider.image:"/images/no_image.png"} onLoad={appendNextSlide} loading={index===0?"eager":"lazy"} decoding={index===0?"auto":"async"} />
              </a>
            </div>
          )
        })
      }
      </div>
      <div className={styles.sliderLeft} onClick={()=>setCurrentSlide(prev=>prev-1 >= 0 ? prev-1 : featured.length-1)}></div>
      <div className={styles.sliderRight} onClick={()=>setCurrentSlide(prev=>prev+1 < featured.length ? prev+1 : 0)}></div>
      <div className={styles.sliderBar}>
        {
          featured?featured.map((image,index)=>{
            return(
              <div key={index} className={`${styles.sliderDots} ${index===currentSlide?styles.sliderCurrentDot:""}` } onClick={()=>setCurrentSlide(index)}></div>
            );
          }): ""
        }
      </div>
    </div>
    </>): (<div className={styles.featuredPlaceholder}></div>);
  return(
    <>
    {<Header />}
    <div className={styles.fullWrapper}>
      {featuredSlider}
      <div className={styles.section_title_cover}>
        <h2 className={styles.section_title}>Available Products</h2>
      </div>
      <div className={styles.sortby}>
        <label>
          SortBy
          <select onChange={(e)=>Sort(e.target.value)}>
            <option value="recent">Release: Recent</option>
            <option value="old">Release: Old</option>
            <option value="priceLH">Price: Low - High</option>
            <option value="priceHL">Price: High - Low</option>
          </select>
        </label>
          
      </div>
      <div className={styles.products_wrapper}>
        <div className={`${styles.loading} ${!Loading ? styles.complete : ""}`}><div className={styles.loader}></div></div>
        {Array.isArray(Data) && Data.length > 0 ? (
          Data.map((item) => {
            const productTitle = item.title.slice(0,60)+"...";
            const productPrice = item.price;
            const productDiscount = item.discount;
            const getImage = item.thumbnail;

            if (!getImage) return null;

            return (
              <React.Fragment  key={item.variant_id}>
              <div className={styles.thumbnail_cover}>
                <a className={styles.thumbnail_link} href={`/product/${item._id}?variant=${item.variant_id}`} title={item.title}>
                  <img src={getImage} alt="" onLoad={handleLoad} />
                  <span className={styles.thumbnail_price}>
                    ₹{productPrice}
                    {productDiscount > 0 && (
                      <span style={{fontSize:"0.9rem"}}>-{productDiscount}%</span>
                    )}
                  </span>
                </a>
                <a className={styles.thumbnail_text} href={`/product/${item._id}?variant=${item.variant_id}`} title={item.title}>
                  {productTitle}
                </a>
              </div>
              </React.Fragment>
            );
          })
        ) : (
          "Loading..."
        )}
      </div>
    </div>
    {<Footer />}
    </>
  );
}
export default Home;